<script>
import { mapMutations, mapGetters, mapState } from 'vuex'

// import { lengthError } from 'src/plugins/validations'
export default {
  name: 'CourseGeneral',
  props: ['courseForm', 'validation'],
  data () {
    return {
      // stateOptions: this.$store.state.shared.options.states
    }
  },
  computed: {
    ...mapGetters([
      'stateOptions'
    ]),
    stateIds () {
      return this.courseForm.STATES.map(state => state.LK_STATE_ID)
    }

  },
  methods: {
    ...mapMutations('courses', [
      'updateCourseForm',
      'updateSelectedTab'
    ]),
    ...mapMutations([
      'closeDetails'
    ]),
    updateStates(statesIds) {
      const newStates = stateIds.map(stateId => { return { LK_STATE_ID: stateId } })
      this.updateCourseForm({ field: 'STATES', value: newStates })
    },
    test(val) {
    }
  }
}
</script>

<template>
  <div class="q-pa-md">
    <div class="q-pb-sm">
      <h6> Details </h6>
      <div class="row">
        <q-field 
          class="q-pa-md col-12"
          :error="validation.courseForm.COURSE_NAME.$error"
          error-label="Must have more than 4 characters"
        >
          <q-input
            float-label="Course Name"
            :value="courseForm.COURSE_NAME"
            @blur="validation.courseForm.COURSE_NAME.$touch"
            @keyup.stop="updateCourseForm({ field: 'COURSE_NAME', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
      </div>
      <div class="row">
        <q-field 
          class="q-pa-md col-12">
          <q-select
            chips
            multiple
            float-label="Associated States"
            :value="stateIds"
            :options="stateOptions"
            @input="stateIds => this.updateCourseForm({ 
              field: 'STATES', 
              value: stateIds.map(stateId => { 
                return { LK_STATE_ID: stateId } 
              })
            })"
          />
        </q-field>
      </div>
    </div>
    <div class="q-py-sm">
      <div class="row">
        <q-field class="q-pa-md col-4"
          :error="validation.courseForm.COURSE_LENGTH_HOURS.$error"
          error-label="Hours must be less than 24"
        >
          <q-input
            float-label="Hours"
            type="number"
            :value="courseForm.COURSE_LENGTH_HOURS"
            @blur="validation.courseForm.COURSE_LENGTH_HOURS.$touch"
            @keyup.stop="updateCourseForm({ field: 'COURSE_LENGTH_HOURS', value:  Number.parseInt($event.target.value) })"
            required>
          </q-input>
        </q-field>
        <q-field class="q-pa-md col-4"
          :error="validation.courseForm.COURSE_LENGTH_MINUTES.$error"
          error-label="Value must be less than 60"
        >
          <q-input
            float-label="Minutes"
            type="number"
            :value="courseForm.COURSE_LENGTH_MINUTES"
            @blur="validation.courseForm.COURSE_LENGTH_MINUTES.$touch"
            @keyup.stop="updateCourseForm({ field: 'COURSE_LENGTH_MINUTES', value: Number.parseInt($event.target.value) })"
            required>
          </q-input>
        </q-field>
        <q-field class="q-pa-md col-4"
          :error="validation.courseForm.COURSE_LENGTH_SECONDS.$error"
          error-label="Value must be less than 60"
        >
          <q-input
            float-label="Seconds"
            type="number"
            :value="courseForm.COURSE_LENGTH_SECONDS"
            @blur="validation.courseForm.COURSE_LENGTH_SECONDS.$touch"
            @keyup.stop="updateCourseForm({ field: 'COURSE_LENGTH_SECONDS', value: Number.parseInt($event.target.value) })"
            required>
          </q-input>
        </q-field>
      </div>
      <div class="row" style="margin-top:20px">
        <q-field>
          <q-checkbox v-model="courseForm.DISABLE_APPROVAL_PROCESS" label="Disable Approval Process" :true-value="1" :false-value="0"  />
        </q-field>
      </div>
      <div class="row">
        <q-field>
          <q-checkbox v-model="courseForm.DISABLE_PAYMENTS" label="Disable Payments" :true-value="1" :false-value="0" />
        </q-field>
      </div>
      <div class="row">
        <q-field>
          <q-checkbox v-model="courseForm.ENABLE_NY_REPORTS" label="Enable NY Reports" :true-value="1" :false-value="0" />
        </q-field>
      </div>
    </div>
  </div>
</template>

<style>

</style>
